<template>
  <div class="flex flex-col gap-4">
    <h1 class="font-bold text-blue-70 sm:text-xl">{{ agency.Name }}</h1>
    <HorizontalSeparator />

    <template v-if="loading">
      <span class="text-lg">Loading branches for your selected agency...</span>
    </template>

    <template v-if="!loading">
      <span
        v-if="alreadySelectedBranch"
        class="cursor-pointer text-blue"
        @click="$emit('selectBranch', previousBranch)"
      >
        (Return to current selected branch - {{ previousBranch.town }})
      </span>

      <div v-for="(towns, region) in locations">
        <h2 class="mb-2 font-bold text-blue-70 sm:text-xl">{{ region }}</h2>
        <ul class="list-inside list-disc text-grey-20">
          <li
            :key="branch"
            v-for="(branch, town) in towns"
            class="cursor-pointer py-1 align-middle"
            @click="$emit('selectBranch', { branch, town })"
          >
            <span class="text-blue">{{ town }}</span>
            <span
              v-if="previousBranch?.branch === branch"
              class="text-xs text-orange"
            >
              (Currently Selected Branch)
            </span>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import HorizontalSeparator from 'Components/HorizontalSeparator';
import { isObject } from 'lodash';

export default {
  name: 'ContactBranchSelectForm',
  components: { HorizontalSeparator },
  props: {
    agency: {
      type: Object,
      default: {},
    },
    locations: {
      type: Object,
      default: {},
    },
    previousBranch: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alreadySelectedBranch() {
      if (this.previousBranch === null) {
        return false;
      }

      for (let region in this.locations) {
        let towns = this.locations[region];

        for (let town in towns) {
          if (towns[town] === this.previousBranch?.branch) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>
